
import {AlertViewModalModel} from "../_models/AlertViewModalModel";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {IModalController} from "../../../controllers/IModalController";

export const MK_ALERT_VIEW_MODAL_MODEL = new ModelKey<AlertViewModalModel>('MK_ALERT_VIEW_MODAL_MODEL');
export const IT_ALERT_VIEW_MODAL_CONTROLLER = new InjectionToken<IAlertViewModalController>('IT_ALERT_VIEW_MODAL_CONTROLLER');

export interface IAlertViewModalController extends IModalController {

}
